var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTable(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "72px",
    height: "72px",
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "C8E8090B-98DB-42C1-9979-404DA42CA255") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M50.4007079,0 C52.3875171,0 54,1.6128 54,3.6 L54,3.6 L53.999,23.238 L54.00018,23.23836 L54.00018,26.83836 L53.999,26.838 L54,43.2 C54,45.1248387 52.4898704,46.6956712 50.5917696,46.7950123 L50.4007079,46.8 L3.60991005,46.8 C1.62310079,46.8 0.0106179118,45.189 0.0106179118,43.2 L0.0106179118,43.2 L0.01,37.638 L0,37.63836 L0,34.03836 L0.01,34.038 L0.0106179118,3.6 C0.0106179118,1.67690323 1.52074756,0.104441207 3.4188483,0.00499318586 L3.60991005,0 Z M14.397,37.638 L3.609,37.638 L3.60991005,43.2 L14.397,43.199 L14.397,37.638 Z M34.193,37.638 L17.996,37.638 L17.996,43.199 L34.193,43.199 L34.193,37.638 Z M50.4,37.638 L37.803,37.638 L37.803,43.199 L50.4007079,43.2 L50.4,37.638 Z M14.397,26.838 L3.609,26.838 L3.609,34.038 L14.397,34.038 L14.397,26.838 Z M34.193,26.838 L17.996,26.838 L17.996,34.038 L34.193,34.038 L34.193,26.838 Z M50.4,26.838 L37.803,26.838 L37.803,34.038 L50.4,34.038 L50.4,26.838 Z M50.4007079,3.6 L3.60991005,3.6 L3.609,23.238 L14.397,23.238 L14.3971686,10.63836 L17.9964607,10.63836 L17.996,23.238 L34.193,23.238 L34.1932753,10.63836 L37.8033653,10.63836 L37.803,23.238 L50.4,23.238 L50.4007079,3.6 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54,14.4 L0,14.4 L0,3.6 C0,1.6128 1.6128,0 3.6,0 L50.4,0 C52.3872,0 54,1.6128 54,3.6 L54,14.4 Z",
    id: "path-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web-Page-Builder-v1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "8.0-WebPageBuilder-EmptyWidgets",
    transform: "translate(-1120.000000, -322.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Map-Copy",
    transform: "translate(892.000000, 152.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(120.000000, 170.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-Builder/Data-Grid/40dp",
    transform: "translate(108.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Purple-Light",
    transform: "translate(9.000000, 12.600000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#E5E5E5",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Zinier-Colors/Grey-Light",
    mask: "url(#mask-2)",
    fill: "#E5E5E5"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-9.000000, -12.600000)",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 115.2,
    height: 115.2
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Purple",
    transform: "translate(9.000000, 12.600000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#E5E5E5",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Zinier-Colors/Grey-Light",
    mask: "url(#mask-4)",
    fill: "#E5E5E5"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-9.000000, -12.600000)",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 115.2,
    height: 115.2
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTable);
export default __webpack_public_path__ + "static/media/table.7fefd63078af88b89c5c85bb187d58a3.svg";
export { ForwardRef as ReactComponent };